import {useState, useContext} from 'react';
import {
    CompanyLogo,
    HeaderNavMenu,
    HeaderMainMenu,
    HeaderTop,
    MainMenu,
    ScrollToTop,
} from '@/components/export';

import appContext from '@/appContext.tsx';

export const Header = () => {
    const {
        currentUser,
        // globalMessage
    } = useContext(appContext).userContext;

    const [showMainMenu, setShowMainMenu] = useState(false);
    // const [bannerShow, setBannerShow] = useState(
    //     localStorage.getItem('bannerShow') !== null ?
    //         JSON.parse(localStorage.getItem('bannerShow')) :
    //     true
    // );

    // const hideBanner = () => {
    //     setBannerShow(false);
    //     localStorage.setItem('bannerShow', JSON.stringify(false));
    // }

    // fixme: duplicate - move to utils
    // const currentPath = window.location.pathname.split('/')[1];
    // const publicPath = ['login', 'welcome'];

    return <>
        <ScrollToTop />
        <div className="header-wrapper--static">
            {/*{*/}
            {/*    (bannerShow && globalMessage) || publicPath.includes(currentPath) ?*/}
            {/*        <div className={*/}
            {/*            "header-banner-wrapper container" +*/}
            {/*            (!bannerShow ? ' hidden' : '')*/}
            {/*        }>*/}
            {/*            {*/}
            {/*                globalMessage ?*/}
            {/*                    <div*/}
            {/*                        onClick={() => hideBanner()}*/}
            {/*                        className={'header-banner style-1'}*/}
            {/*                    >*/}
            {/*                        <span>{globalMessage}</span>*/}
            {/*                        <div className="header-banner-closeBtn">*/}
            {/*                            <i className={'iconfa-close'}></i>*/}
            {/*                        </div>*/}
            {/*                    </div> : <></>*/}
            {/*            }*/}
            {/*            /!*{*!/*/}
            {/*            /!*    publicPath.includes(currentPath) ?*!/*/}
            {/*            /!*        <div className={'header-banner style-3'}>*!/*/}
            {/*            /!*            <span>*!/*/}
            {/*            /!*                <span className='icon iconfa-info' /> Soutěž pro B2B o hodnotné ceny! Nakup a vyhraj. <a href="https://www.cemat.cz/cz/novinky/nakupte-na-nasem-e-shopu-a-vyhrajte/151.html" target='_blank'>Pravidla soutěže</a>*!/*/}
            {/*            /!*            </span>*!/*/}
            {/*            /!*        </div> :*!/*/}
            {/*            /!*        <></>*!/*/}
            {/*            /!*}*!/*/}
            {/*        </div>: <></>*/}
            {/*}*/}
        </div>
        <div className="header-wrapper">
            <HeaderTop />

            <div className="header-main">
                <div className="header-main__container container">
                    <CompanyLogo/>

                    <div className="header-main__nav">
                        <CompanyLogo/>

                        {currentUser.id ? <HeaderNavMenu/> : <></>}
                    </div>

                    {
                        currentUser.id ?
                            <HeaderMainMenu
                                onToggleMenu={() => setShowMainMenu(!showMainMenu)}
                                active={showMainMenu}
                            /> :
                            <></>
                    }
                </div>
            </div>
        </div>
        {
            showMainMenu ?
                <MainMenu onClick={() => setShowMainMenu(false)} /> :
                <></>
        }
    </>;
};
